<template>
  <div>
    <div class="spcore-box" :style="`background-color: ${background || '#f5fbfb'}`">
      <div class="v-card__title pb-3 pl-4">
        <div class="hvh-analysis-visualization__title">
          <h2 class="hvh-h6">{{ title }}</h2>
        </div>
        <div class="spacer"></div>
      </div>
      <div class="v-card__text px-0">
        <div class="hvh-analysis-visualization__chart">
          <BarchartFilter
            class="px-5 pb-4"
            :style="`background-color: ${background || '#f5fbfb'}`"
            :nameField="nameField"
            :valueField="valueField"
            :filterObject="filterObject"
            :isChecked="isChecked"
            :data="data"
            :options="chartOptions"
            :isFiltering="isFiltering"
            :displayedBarChartData="10"
            height="288px"
            @checked-changed="emitChange"
            @chart-created="$emit('refresh-data', $event)"
            @refresh-data="$emit('refresh-data', $event)"
          />
          <div class="pr-4" style="text-align: end" v-if="clickText">
            <span class="clickable">{{ clickText }} ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarchartFilter from '../analysis/filters/BarchartFilter.vue';
export default {
  noExport: true,
  components: { BarchartFilter },
  props: ['title', 'data', 'filterObject', 'isFiltering', 'selected', 'valueField', 'nameField', 'clickText', 'background'],
  data() {
    return {
      chartOptions: {
        backgroundColor: this.background || '#f5fbfb',
      },
    }
  },
  methods: {
    emitChange(event, data) {
      this.$emit('checked-changed', event, data);
    },
    isChecked(event) {
      return !(this.selected || []).length || (this.selected || []).includes(event.filterValue);
    },
  },
}
</script>
